import { useCafeteriaSelection } from '../../../context/CafeteriaSelectionContext';
import { useDashboardData } from '../../../hooks/useDashboardData';
import StatsCards from '../../../components/dashboard/StatsCard';
import StatsCardSkeleton from '../../../components/dashboard/StatsCardSkeleton';
import RecentReviews from '../../../components/dashboard/RecentReviews';
import ReviewsSkeleton from '../../../components/dashboard/ReviewsSkeleton';
import PopularProducts from '../../../components/dashboard/PopularProducts';
import ProductsSkeleton from '../../../components/dashboard/ProductsSkeleton';

const DashboardPage = () => {
  const { currentCafeteria, isLoading: isLoadingCafeteria } = useCafeteriaSelection();
  const {
    stats,
    recentReviews,
    popularProducts,
    loadingStats,
    loadingReviews,
    loadingProducts,
    errorStats,
    errorReviews,
    errorProducts,
    refetchStats,
    refetchReviews,
    refetchProducts,
  } = useDashboardData(currentCafeteria?.id || '');

  if (isLoadingCafeteria) {
    return (
      <div className="space-y-6 animate-fade-in">
        <div className="text-center py-12">
          <div className="w-24 h-24 bg-coffee-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
            <div className="w-12 h-12 bg-coffee-200 rounded-full"></div>
          </div>
          <div className="h-8 bg-coffee-200 rounded-lg w-48 mx-auto mb-4 animate-pulse"></div>
          <div className="h-6 bg-coffee-200 rounded-lg w-64 mx-auto animate-pulse"></div>
        </div>
      </div>
    );
  }

  if (!currentCafeteria) {
    return (
      <div className="space-y-6 animate-fade-in">
        <div className="text-center py-12">
          <div className="w-24 h-24 bg-coffee-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-coffee-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-neutral-900 mb-2">Dashboard</h1>
          <p className="text-neutral-600 text-lg">
            Selecione uma cafeteria para ver o dashboard
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8 animate-fade-in">
      {/* Header do Dashboard */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div>
          <p className="text-neutral-600 text-lg">
            Olá, <b>{currentCafeteria.name}</b>
          </p>
          {/* <div className="flex items-center space-x-3 mt-2">
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
              currentCafeteria.isActive 
                ? 'bg-success-100 text-success-800' 
                : 'bg-warning-100 text-warning-800'
            }`}>
              {currentCafeteria.isActive ? 'Ativa' : 'Inativa'}
            </span>
          </div> */}
        </div>
        
        {/* Seletor de período */}
        <div className="flex items-center space-x-3">
          <div className="relative">
            <select className="appearance-none bg-white border-2 border-neutral-200 rounded-xl px-4 py-2.5 pr-10 text-sm font-medium text-neutral-700 focus:ring-2 focus:ring-coffee-500 focus:border-coffee-500 transition-all duration-200 cursor-pointer hover:border-neutral-300">
              <option>Últimos 7 dias</option>
              <option>Últimos 30 dias</option>
              <option>Últimos 90 dias</option>
              <option>Este ano</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg className="w-4 h-4 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          
          {/* <button className="btn btn-primary">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Exportar Relatório
          </button> */}
        </div>
      </div>

      {/* Cards de Estatísticas */}
      {loadingStats ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[1, 2, 3, 4].map((item) => (
            <StatsCardSkeleton key={item} />
          ))}
        </div>
      ) : errorStats ? (
        <div className="card">
          <div className="card-body text-center">
            <div className="w-16 h-16 bg-error-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-error-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <p className="text-error-600 mb-4 font-medium">{errorStats}</p>
            <button 
              onClick={refetchStats}
              className="btn btn-outline"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      ) : stats ? (
        <StatsCards stats={stats} />
      ) : null}

      {/* Seções de Conteúdo */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Coluna principal - 2/3 */}
        <div className="lg:col-span-2 space-y-8">
          {/* Avaliações Recentes */}
          {loadingReviews ? (
            <ReviewsSkeleton />
          ) : errorReviews ? (
            <div className="card">
              <div className="card-header">
                <h3 className="text-lg font-semibold text-neutral-900">
                  Avaliações Recentes
                </h3>
              </div>
              <div className="card-body text-center">
                <div className="w-16 h-16 bg-error-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-error-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <p className="text-error-600 mb-4 font-medium">{errorReviews}</p>
                <button 
                  onClick={refetchReviews}
                  className="btn btn-outline"
                >
                  Tentar novamente
                </button>
              </div>
            </div>
          ) : (
            <RecentReviews reviews={recentReviews} />
          )}

          {/* Produtos Populares */}
          {loadingProducts ? (
            <ProductsSkeleton />
          ) : errorProducts ? (
            <div className="card">
              <div className="card-header">
                <h3 className="text-lg font-semibold text-neutral-900">
                  Produtos Mais Populares
                </h3>
              </div>
              <div className="card-body text-center">
                <div className="w-16 h-16 bg-error-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-error-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <p className="text-error-600 mb-4 font-medium">{errorProducts}</p>
                <button 
                  onClick={refetchProducts}
                  className="btn btn-outline"
                >
                  Tentar novamente
                </button>
              </div>
            </div>
          ) : (
            <PopularProducts products={popularProducts} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage; 